<ms-event-header
    [isEventNameALink]="isEventNameALink"
    [event]="event"
    [isOutrightMarket]="isOutrightMarket"
    [eventUrl]="eventUrl"
    [media]="media"
    [isAllBetsButtonVisible]="isAllBetsButtonVisible"
    [state]="state"
    [tracking]="tracking"
    (getToggle)="toggle()" />

<ng-container *ngIf="!state?.collapsed">
    <ng-container *ngIf="optionGroups.length; else empty">
        <ms-option-panel
            *ngFor="let optionGroup of optionGroups; trackBy: trackByFn"
            [optionGroup]="optionGroup"
            [event]="event"
            [tracking]="trackingSource"
            [thresholds]="config.optionCollapseSize"
            [collapsed]="collapsed(optionGroup)"
            [toggleable]="isMarketGroupToggable"
            [scrollAdapterButtonSize]="scrollAdapterButtonSize"
            [optionGroupLinkable]="isOptionGroupLinkable"
            [betDetails]="betDetails"
            [hideMarketHeader]="hideOptionPanelHeaderForPriceBoost"
            [marketLogoShow]="true"
            [calendarTitle]="tracking?.calendarTitle"
            (collapsedChange)="collapsedChanged(optionGroup)" />
    </ng-container>

    <ng-template #empty>
        <div class="empty-panel">
            <ms-error severity="info" [message]="sitecore.eventGrid.NonGridableEmpty" [links]="false" />
        </div>
    </ng-template>
</ng-container>
